import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function AgitationSection() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);
  return <section ref={ref} className="py-24 md:py-32 bg-[#1E1A16]" data-id="element-13">
      <div className="container mx-auto px-6 md:px-12" data-id="element-14">
        <div className="flex flex-col md:flex-row items-center gap-16 lg:gap-24" data-id="element-15">
          <motion.div className="w-full md:w-1/2" initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-16">
            <h2 className="font-serif text-4xl md:text-5xl mb-8 leading-tight" data-id="element-17">
              El Verdadero Costo de un{' '}
              <span className="text-gold italic" data-id="element-18">Mal Corte</span>
            </h2>
            <div className="w-16 h-[1px] bg-gold mb-8" data-id="element-19"></div>
            <p className="text-white/70 text-lg leading-relaxed font-light" data-id="element-20">
              Alguna vez has salido de una barbería sabiendo que algo no estaba
              bien. El desvanecido desigual. La línea torcida. La sensación de
              pagar por mediocridad.
              <br data-id="element-21" />
              <br data-id="element-22" />
              Un mal corte no solo te cuesta dinero — te cuesta confianza,
              primeras impresiones y la versión de ti mismo que mereces
              presentar al mundo.
            </p>
          </motion.div>
          <motion.div className="w-full md:w-1/2" initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-23">
            <motion.div style={{
            y
          }} className="relative rounded-2xl overflow-hidden shadow-2xl shadow-gold/10 hover:-translate-y-2 transition-transform duration-500" data-id="element-24">
              <div className="absolute inset-0 bg-gold/5 mix-blend-overlay z-10 pointer-events-none" data-id="element-25"></div>
              <img src="https://cdn.magicpatterns.com/uploads/mjYDdFyFMjSDAAzKdBxXFa/Imagen_1.webp" alt="Barber shaving client" className="w-full h-auto object-cover aspect-[4/5] md:aspect-square hover:scale-105 transition-transform duration-1000" data-id="element-26" />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}